import React, { useEffect, useState } from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart, ArcElement, Tooltip, Legend } from "chart.js";
import Card from "components/card";

Chart.register(ArcElement, Tooltip, Legend);

const ReportDonutChart = ({ donutInfo }) => {
  const [chartsData, setChartsData] = useState([]);

useEffect(() => {
    if (donutInfo) {
      const preparedCharts = donutInfo.map((data) => {
        // 1. Destructure exactly what your API sends
        const { DonutChartName, plotData } = data;

        // 2. Map over the plotData array to extract labels and values
        const labels = plotData.map((item) => item.category); // ["Cold (< 20 °C)", "Optimal...", "Hot..."]
        const dataValues = plotData.map((item) => item.value); // [85, 1089, 994]

        // 3. Generate background colors for each slice
        // (Assuming you have a getColor(index) function defined in your file)
        const backgroundColors = plotData.map((_, index) => getColor(index));

        return {
          title: DonutChartName,
          chartData: {
            labels: labels, // Assign categories to the chart labels
            datasets: [
              {
                data: dataValues, // Assign the values to the chart slices
                backgroundColor: backgroundColors,
                borderWidth: 1,
              },
            ],
          },
        };
      });

      setChartsData(preparedCharts);
    }
  }, [donutInfo]);

  // Utility function to get colors for each dataset
  const getColor = (index) => {
    const colors = [
      "#42AACC",
      "#EE5D50",
      "#4299e1",
      "#A3AED0",
      "#D69E2E",
      "#809D3C",
      "#A35C7A",
    ];
    return colors[index % colors.length];
  };

  if (chartsData.length === 0) return <div>Loading...</div>;

  return (
    <div
      className="grid gap-5"
      style={{
        gridTemplateColumns: `repeat(${Math.min(
          chartsData.length,
          4
        )}, minmax(0, 1fr))`,
      }}
    >
      {chartsData.map((chart, index) => (
        <Card key={index} extra="rounded-[20px] p-3 h-[450px] relative">
          <div className="flex flex-row justify-between px-3 pt-2">
            <h4 className="text-lg font-bold text-navy-700 dark:text-white">
              {chart.title}
            </h4>
          </div>

          <div
            className="mb-auto flex h-[380px] w-full items-center justify-center"
            style={{
              maxHeight: "300px",
              maxWidth: "100%",
              marginTop: "20px",
            }}
          >
            <Doughnut
              data={chart.chartData}
              options={{
                responsive: true,
                plugins: {
                  legend: {
                    display: true,
                    position: "bottom",
                    labels: {
                      color: "#000",
                      generateLabels: (chart) => {
                        const { datasets } = chart.data;
                        return datasets.map((dataset, i) => ({
                          text: dataset.label,
                          fillStyle: dataset.backgroundColor,
                        }));
                      },
                    },
                  },
                },
              }}
            />
          </div>
        </Card>
      ))}
    </div>
  );
};

export default ReportDonutChart;
